// extracted by mini-css-extract-plugin
export var adjacentSlide = "_kw-9";
export var arrowButtonContainer = "_kw-5";
export var arrowButtonIcon = "_kw-6";
export var carouselArrowButton = "_kw-2";
export var carouselElementContainer = "_kw-1";
export var currentSlide = "_kw-8";
export var left = "_kw-3";
export var otherSlide = "_kw-a";
export var productCarouselContainer = "_kw-0";
export var right = "_kw-4";
export var sliderOverflow = "_kw-7";